import WelcomeProImage from 'assets/svgs/onboardingAlpha/welcome-pro.svg';
import PlaybookImage from 'assets/svgs/onboardingAlpha/playbook.svg';
import Welcome from '../components/Welcome';
import { IconArrowForward, Typography } from '@capitalise/ui-design-system';
import ImageTitleDescription from 'components/ImageTitleDescription';
import HelpButton from '../components/HelpButton';
import AccountSetupImage from 'assets/svgs/account-setup.svg';
import ScheduleButton from '../components/ScheduleButton';
import CreditScoreGuy from 'assets/svgs/credit-score-guy.svg';
import GrowFundingGirl from 'assets/svgs/grow-funding-girl.svg';
import { openIntercomChat } from 'utils/openIntercomChat';

export default ({ completeOnboarding, goToRoute }) => {
  return [
    {
      label: 'Welcome',
      lead: 'We’re excited to have you onboard as a member of Capitalise Pro.',
      title: 'Welcome to the next level!',
      component: Welcome,
      iconButton: IconArrowForward,
      nextButtonLabel: 'Next',
      image: WelcomeProImage,
    },
    {
      lead: 'Get started in your practice with a powerful business finance partnership. Experian powered credit scores to help with pre-funding checks and monitoring financial health.',
      label: 'Insights',
      title: 'Insights and credit scores for your clients!',
      component: ImageTitleDescription,
      hasPrevious: true,
      image: CreditScoreGuy,
      iconButton: IconArrowForward,
    },
    {
      lead: 'Help get your clients funding-ready by preparing their applications. Then submit - with our support - to over 100+ lenders through our marketplace to secure offers of finance for your clients.',
      label: 'Funding',
      title: 'Funding - made easy with specialist support',
      component: ImageTitleDescription,
      hasPrevious: true,
      image: GrowFundingGirl,
      iconButton: IconArrowForward,
    },
    {
      label: 'Playbook',
      title: 'Let’s start the Playbook',
      component: ImageTitleDescription,
      hasPrevious: true,
      image: PlaybookImage,
      iconButton: IconArrowForward,
      lead: 'Helpful marketing and strategic documents on how to turn Capitalise into a service line in your firm.',
      children: (
        <HelpButton
          helpLabel={
            <Typography size="body-16" color="grey-900">
              When <span style={{ fontWeight: 500 }}>at least 50%</span> of your team have completed
              the Learn modules we’ll arrange for you on-site funding training.
            </Typography>
          }
          buttonLabel="Start Learn"
          onClickCallback={() => {
            completeOnboarding();
            goToRoute('/learning/playbook');
          }}
        />
      ),
    },
    {
      label: 'All set',
      title: 'Your account is set up!',
      component: ImageTitleDescription,
      hasPrevious: true,
      image: AccountSetupImage,
      iconButton: null,
      lead: 'Your Capitalise partnership manager will schedule a kick-off meeting with you shortly.',
      nextButtonLabel: 'Go to dashboard',
      nextButtonAction: () => {
        completeOnboarding();
      },
      children: (
        <ScheduleButton
          helpLabel={
            <Typography size="heading-16" color="grey-900">
              Want to book a kick-off call now?
            </Typography>
          }
          buttonLabel="Schedule a call"
          onClickCallback={() => {
            openIntercomChat();
            completeOnboarding();
          }}
        />
      ),
    },
  ];
};
